import React, { useState, memo, useRef, useEffect } from "react";
import {
  IonGrid,
  IonRow,
  IonCol,
  IonCardContent,
  IonCardTitle,
  IonIcon,
  IonButton,
  IonThumbnail,
  isPlatform,
  IonInput
} from "@ionic/react";
import "./UploadDocument.scss";
import i18n from "../../../../i18n";
import { ToastMessage } from "../../../utils/ToastMessage";
// import { SortableContainer, SortableElement } from "react-sortable-hoc";
import {
  IONICWrapper,
  isMobile,
  getConfigWithSourceTMSValidation,
} from "../../../utils/common";
import {
  CAMERA_SOURCE,
  CONTENT_OR_CONFIG_TABLE_MAPPING,
  MYLOAD_DOCUMENT_UPLOAD,
  ESOURCE_TYPE_CHECK,
  ENTER_INVOICE_ID_HEADER,
  INVOICE_CARRIER_PRO_ID_INPUT,
  DEFAULT_UPLOAD_DOCUMENT_TYPE,
} from "../../../utils/constants";
import { useDispatch } from "react-redux";
import {
  saveTmsDocumentNew,
} from "../../../actions/myload/action";
import { logEvent } from "../../../utils/Analytics";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { ToolTip } from "../../ToolTip/ToolTip";
import {
  getPayLoadShipmentId,
  getSourceSystemDetails,
  getDocTypeDetails,
  payloadCreationForDocUpload,
} from "./utils";
import { isInvoiceInputFieldVisible } from "app/utils/sourceTMSAndDivisionFilter";
export const UploadDocument = (props: any) => {
  let {
    uploadedDocuments,
    selectedUploadDocumentType,
    handleSelectedUploadDocumentTypeChange,
    handleFileChange,
    updateUploadedDocuments,
    executionStarted,
    handleInvoiceIdChange,
    invoiceID,
    ppkWrkPage,
    invoiceCreatedDateTime,
    carrierProID,
  } = props;
  const dispatch = useDispatch();
  const isMobile = getPlatformDetails();
  const inputRef = useRef<HTMLInputElement>(null);
  const [isError, setIsError] = useState("");
  const handleDocumentSubmit = async () => {
    let payload = payloadCreationForDocUpload({
      shipmentId: getPayLoadShipmentId(props),
      sourceSystem: getSourceSystemDetails(props),
      docType: getDocTypeDetails(selectedUploadDocumentType) || DEFAULT_UPLOAD_DOCUMENT_TYPE,
      documents: uploadedDocuments,
      division: props?.division || "",
      invoiceNumber: carrierProID ? carrierProID : invoiceID || ""
    });
    const callback = (responseType: string, data: any) => {
      if (responseType === "success") {
        logEvent(EVENT.UE_DOC_SUBMISSION_SUCCESS, {
          screen: SCREEN.MYLOADS_DOCUMENT,
          carrierId:
            props.userDetails &&
            props.userDetails.memberDetailsResponse &&
            props.userDetails.memberDetailsResponse.member &&
            props.userDetails.memberDetailsResponse.member.carrierId,
          shipmentId: getPayLoadShipmentId(props),
          documentType: getDocTypeDetails(selectedUploadDocumentType) || DEFAULT_UPLOAD_DOCUMENT_TYPE,
          dateTime: new Date().toISOString(),
        });
        handleSelectedUploadDocumentTypeChange({});
        updateUploadedDocuments([]);
        data && data.message && isMobile
          ? ToastMessage.show(data.message)
          : ToastMessage.showWeb(data.message);
      } else if (responseType === "failed") {
        logEvent(EVENT.UE_DOC_SUBMISSION_FAILURE, {
          screen: SCREEN.MYLOADS_DOCUMENT,
          carrierId:
            props.userDetails &&
            props.userDetails.memberDetailsResponse &&
            props.userDetails.memberDetailsResponse.member &&
            props.userDetails.memberDetailsResponse.member.carrierId,
          shipmentId: getPayLoadShipmentId(props),
          documentType: getDocTypeDetails(selectedUploadDocumentType) || DEFAULT_UPLOAD_DOCUMENT_TYPE,
          dateTime: new Date().toISOString(),
        });
      }
    };
    dispatch(
      saveTmsDocumentNew({
        query: payload,
        callback,
      })
    );
  };
  const handleDragAndDrop = (param: any) => {
    const { oldIndex, newIndex } = param;
    let temp = [...uploadedDocuments];
    temp.splice(newIndex, 0, temp.splice(oldIndex, 1)[0]);
    let result = temp.map((item: any, index: number) => {
      return { ...item, rank: index + 1 };
    });
    updateUploadedDocuments(result);
  };

  const uploadDocumentTypeList: Array<any> = getConfigWithSourceTMSValidation(props?.sourceTMS,props?.division,ESOURCE_TYPE_CHECK.UPLOAD_DOCUMENT_TYPE);
  const approvedDocumentFormat: string = getApprovedDocumentFormat();
  const webGalleryButtonTitle: string = getWebGalleryButtonTitle();
  const SelectionTypeErrorMsg: string =
    (IONICWrapper.details.getKeyValuePairs(
      CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
    ) &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG.documentTypeSelectionErrorMessage) ||
    MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG
      .documentTypeSelectionErrorMessage;
  return (
    <div className="UploadDocument">
      {executionStarted &&
        (!!ppkWrkPage ? true : !ppkWrkPage && !invoiceCreatedDateTime) && (
          <>
            {!ppkWrkPage && (
              <IonCardTitle
                className="title"
                style={{ textAlign: isMobile ? "center" : "left" }}
              >
                {i18n.t("Add Documents")}
              </IonCardTitle>
            )}
            <IonCardContent>
              <div>
                <IonGrid>
                  {!!props?.carrierProId ? isInvoiceInputFieldVisible(props?.sourceTMS, props?.division) ?(
                    <IonRow className="upload_Header">
                      <div>{`${ENTER_INVOICE_ID_HEADER}/${INVOICE_CARRIER_PRO_ID_INPUT}`}</div>
                    </IonRow>
                  ) : null : null}
                  <IonRow
                    className={`ion-padding-vertical ${selectedUploadDocumentType &&
                      Object.keys(selectedUploadDocumentType).length === 0 &&
                      "ion-margin-bottom"}`}
                  >
                    <IonCol size={ppkWrkPage ? "3.8" : "6.4"} offset="0.3">
                      {ppkWrkPage ? (
                        props?.invoiceRadio !== "YES" && isInvoiceInputFieldVisible(props?.sourceTMS, props?.division) &&
                        <IonInput
                          value={carrierProID ? carrierProID : invoiceID}
                          className="invoice-id-input"
                          onIonChange={handleInvoiceIdChange}
                          placeholder={`${ENTER_INVOICE_ID_HEADER}/${INVOICE_CARRIER_PRO_ID_INPUT}`}
                        />
                      ) : uploadDocumentTypeList && uploadDocumentTypeList?.length > 0 ? (
                        <>
                          <div>
                            <span id="typeSelection">
                              Select Type<sup>*</sup>
                            </span>
                          </div>
                          <div>
                            <NewDropDown
                              listData={uploadDocumentTypeList}
                              selectedUploadDocumentType={
                                selectedUploadDocumentType
                              }
                              handleChange={(e: any) => {
                                setIsError("");
                                handleSelectedUploadDocumentTypeChange(e);
                              }}
                              uploadedDocuments={uploadedDocuments}
                              isError={isError}
                              executionStarted={executionStarted}
                            />
                            {isError !== "" && (
                              <p className="error-message">{isError}</p>
                            )}
                          </div>
                        </>
                      ): null}
                    </IonCol>
                    {!isMobile && (
                      ppkWrkPage ?  props?.invoiceRadio === "YES" &&  <IonCol
                      size="3.88"
                      className="fileUploader"
                    >
                      <div className="uploader">
                        <IonIcon
                          src="assets/icon/documentSearchOutline.svg"
                          className="icon"
                          size="large"
                        />
                        <span
                          className="text"
                          onClick={() => {
                            if (
                              selectedUploadDocumentType &&
                              Object.keys(selectedUploadDocumentType)
                                .length === 0 &&
                              !ppkWrkPage
                            ) {
                              setIsError(SelectionTypeErrorMsg);
                              ToastMessage.showWeb(SelectionTypeErrorMsg);
                            } else {
                              if (inputRef.current != null) {
                                inputRef.current.click();
                              }
                            }
                          }}
                        >
                         {i18n.t("Browse Document")}
                        </span>
                      </div>
                      <input
                        style={{ display: "none" }}
                        ref={inputRef}
                        type="file"
                        onChange={handleFileChange}
                        multiple
                        accept={approvedDocumentFormat}
                      />
                    </IonCol> : 
                      <IonCol
                        size={uploadDocumentTypeList && uploadDocumentTypeList?.length > 0 ? "4.7" : "10"}
                        offset="0.6"
                        className="fileUploader"
                      >
                        <div className={`uploader ${uploadDocumentTypeList && uploadDocumentTypeList?.length > 0 ? '' : 'uploaderCenter'}`}>
                          <IonIcon
                            src="assets/icon/documentSearchOutline.svg"
                            className="icon"
                            size="large"
                          />
                          <span
                            className="text"
                            onClick={() => {
                              if (
                                uploadDocumentTypeList && uploadDocumentTypeList?.length > 0 && selectedUploadDocumentType &&
                                Object.keys(selectedUploadDocumentType)
                                  .length === 0 &&
                                !ppkWrkPage
                              ) {
                                setIsError(SelectionTypeErrorMsg);
                                ToastMessage.showWeb(SelectionTypeErrorMsg);
                              } else {
                                if (inputRef.current != null) {
                                  inputRef.current.click();
                                }
                              }
                            }}
                          >
                            {webGalleryButtonTitle}
                          </span>
                        </div>
                        <input
                          style={{ display: "none" }}
                          ref={inputRef}
                          type="file"
                          onChange={handleFileChange}
                          multiple
                          accept={approvedDocumentFormat}
                        />
                      </IonCol>
                    )}
                  </IonRow>
                  <>
                    {uploadedDocuments.length > 0 && (
                      <IonRow
                        className="uploadPreviewer"
                        data-testid="uploadPreviewer"
                      >
                        <IonCol size={!isMobile && ppkWrkPage ? "12" : "7.5"}>
                          <ThumbnailViewer
                            uploadedDocuments={uploadedDocuments}
                            updateUploadedDocuments={updateUploadedDocuments}
                            onSortEnd={handleDragAndDrop}
                            helperClass="dragging-thumbnail"
                            lockToContainerEdges={true}
                            pressDelay={200}
                            axis="xy"
                          />
                        </IonCol>
                        {!ppkWrkPage && (
                          <IonCol size="4.5" className="SubmitBtnContainer">
                            <IonButton
                              className="secondary-cta-btn-mobile"
                              onClick={handleDocumentSubmit}
                            >
                              Submit
                            </IonButton>
                          </IonCol>
                        )}
                      </IonRow>
                    )}
                  </>
                </IonGrid>
              </div>
            </IonCardContent>
          </>
        )}
    </div>
  );
};

export const NewDropDown: React.FC<any> = memo((props: any) => {
  const {
    listData,
    selectedUploadDocumentType,
    handleChange,
    isError,
    executionStarted,
  } = props;
  const [showOptions, setShowOptions] = useState(false);
  const PreventDocumentErrorMsg: string =
    (IONICWrapper.details.getKeyValuePairs(
      CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
    ) &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG
        .preventDocumentUploadBeforeStartTripErrorMesssage) ||
    MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG
      .preventDocumentUploadBeforeStartTripErrorMesssage;
  const NoDocumentTypeAvailableMsg: string =
    (IONICWrapper.details.getKeyValuePairs(
      CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
    ) &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG.noDocumentTypeAvailableMsg) ||
    MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG.noDocumentTypeAvailableMsg;
  const onConfirm = (option: any) => {
    setShowOptions(false);
    const event = { name: option.name, value: option.value };
    handleChange(event);
  };
  useEffect(() => {
    if (!executionStarted) {
      setShowOptions(false);
    }
  }, [executionStarted]);
  return (
    <div className="dropdown-container">
      <div>
        <IonButton
          type="button"
          className={`dropdown-button ${isError && "error-border"}`}
          data-test="dropdown-click"
          onClick={() => {
            if (!executionStarted) {
              isMobile
                ? ToastMessage.show(PreventDocumentErrorMsg)
                : ToastMessage.showWeb(PreventDocumentErrorMsg);
            } else if (listData.length <= 0) {
              isMobile
                ? ToastMessage.show(NoDocumentTypeAvailableMsg)
                : ToastMessage.showWeb(NoDocumentTypeAvailableMsg);
            } else {
              setShowOptions(showOptions ? false : true);
            }
          }}
        >
          <span className="button-content">
            {selectedUploadDocumentType && selectedUploadDocumentType.name
              ? `${selectedUploadDocumentType.name}`
              : "Select Document Type"}
          </span>
          <i className="down"></i>
        </IonButton>
      </div>

      {showOptions ? (
        <div className="dropdown-list">
          {listData.map((option: any, k: any) => (
            <IonRow key={k} onClick={() => onConfirm(option)}>
              <IonCol
                className={
                  option.name === selectedUploadDocumentType &&
                  selectedUploadDocumentType.name
                    ? "checked"
                    : ""
                }
              >
                {option.name}
              </IonCol>
            </IonRow>
          ))}
        </div>
      ) : null}
    </div>
  );
});

export const ThumbnailViewer = ((props: any) => {
  const { uploadedDocuments, updateUploadedDocuments, references } = props;
  const handleFileRemove = (rank: number) => {
    let temp = [...uploadedDocuments];
    let result: any[] = [];
    temp.forEach((item: any) => {
      if (item.rank < rank) {
        result.push(item);
      } else if (item.rank > rank) {
        const data = item.source
          ? {
              rank: item.rank - 1,
              content: item.content,
              source: CAMERA_SOURCE,
            }
          : { rank: item.rank - 1, content: item.content };
        result.push(data);
      }
    });
    updateUploadedDocuments(result);
  };
  return (
    <div className="thumbnailViewer">
      {uploadedDocuments
        .sort((a: any, b: any) => a.rank - b.rank)
        .map((item: any, index: number) => {
          return (
            <SortableItem
              item={item}
              references={references}
              handleFileRemove={handleFileRemove}
              key={`item-${item.rank}`}
              index={index}
            />
          );
        })}
    </div>
  );
});
const SortableItem = ((props: any) => {
  const { item, handleFileRemove } = props;
  const [toolTip, setTooltip] = useState(null);
  return (
    <IonThumbnail
      data-testid="img-file-thumbnail"
      onMouseEnter={() =>
        setTooltip(
          item.content && item.content.name.replace(/(.{12})..+/, "$1…")
        )
      }
      onMouseLeave={() => setTooltip(null)}
    >
      <img
        src={
          item.content.type !== "application/pdf"
            ? item.source && item.source === CAMERA_SOURCE
              ? item.content
              : URL.createObjectURL(item.content)
            : "assets/icon/PDFPic.svg"
        }
      />
      <img
        src={"assets/icon/Cross.svg"}
        className="closeBtn"
        data-testid="img-file-remove"
        onClick={() => handleFileRemove(item.rank)}
      />
      <ToolTip message={toolTip} isActive={!!toolTip} />
    </IonThumbnail>
  );
});

const getPlatformDetails = () => {
  return isPlatform("mobile") || isPlatform("mobileweb");
};

const getApprovedDocumentFormat = (): string => {
  return (
    (IONICWrapper.details.getKeyValuePairs(
      CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
    ) &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG.documentFormat) ||
    MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG.documentFormat
  );
};

const getWebGalleryButtonTitle = (): string => {
  return (
    (IONICWrapper.details.getKeyValuePairs(
      CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
    ) &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG &&
      IONICWrapper.details.getKeyValuePairs(
        CONTENT_OR_CONFIG_TABLE_MAPPING.Document.key
      ).ADD_DOCUMENT_CONFIG.webGalleryButtonTitle) ||
    MYLOAD_DOCUMENT_UPLOAD.ADD_DOCUMENT_CONFIG.webGalleryButtonTitle
  );
};
